import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../autocomplete';
import strings from '../../locales/';

class DynamicListInput extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: null
    }
  }

  onClickHandler = e => {
    this.setState({
      value: e.target.value
    });
  };

  render() {
    return (
      <div className="dynamic-list-input modal-input">
        <select
          data-update={this.props.dataUpdate}
          onChange={this.props.onClickHandler ? this.props.onClickHandler : this.onClickHandler}
          value={this.state.value == null ? this.props.value : this.state.value }
          id={this.props.id}
          className="modal-input"
        >
          <option
            value={""}>
            {this.props.emptyValue}
          </option>
          {
            this.props.list && 
            this.props.list.items.map((item,i)=>{
              if(item.state) {
                return (
                  <option 
                    key={i} 
                    value={item.name}>
                    {item.name}
                  </option>
                );
              }
              return null;
            })
          }
        </select>
      </div>
    );
  }
}

DynamicListInput.propTypes = {};

export default DynamicListInput;



// WEBPACK FOOTER //
// ./source/client/components/common/forms/dynamicListInput.jsx